import { csClient } from './reduxQueryNetworkInterface';

let signalRDetail: any;
let useSignalR: boolean;

export interface ISignalRProps {
  isUseSignalR: boolean;
}

export class SignalRConnector {
  constructor({ isUseSignalR }: ISignalRProps) {
    this.connectToSignalR = this.connectToSignalR.bind(this);
    if (signalRDetail === undefined) {
      useSignalR = isUseSignalR;
    }
  }

  async connectToSignalR() {
    if (!csClient) {
      console.warn('SignalR: csClient is not initialized yet');
      return;
    }
    await csClient.connectToSignalR();
    signalRDetail = csClient.getSignalRDetail();
  }

  public updateUseSignalR(useSignalRValue: boolean) {
    useSignalR = useSignalRValue;
  }

  public async disconnectSignalR() {
    if (!csClient) {
      console.warn('SignalR: csClient is not initialized yet');
      return;
    }
    await csClient.disconnectSignalR();
    signalRDetail = undefined;
  }
}

export default SignalRConnector;
export { signalRDetail, useSignalR };
